import { BrowserRouter, Routes, Route, } from "react-router-dom";
import WowInit from './../../components/wowInit/wowInit';
import Homepage from '../HomePage'


const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <WowInit />
        <Routes>
          <Route path='/' element={<Homepage />} />
          <Route path='home' element={<Homepage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default AllRoute;
